module.exports = __webpack_public_path__ + "img/titleEle.4ac51e45.svg";